export default "__VITE_ASSET__BicVOAu8__"